/* ═══════════════════════════════════════════════════════════════
   REY JOYERO — JS del tema
   Sin dependencias en la carga inicial. GSAP se descarga solo al
   abrir el menú móvil, así la primera vista no paga sus 71 KB.
   ═══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var menosMovimiento = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── Utilidades ───────────────────────────────────────────── */
  function dinero(centavos) {
    return (centavos / 100).toLocaleString('es-MX', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });
  }

  function pedir(url, opciones) {
    return fetch(url, opciones).then(function (r) {
      if (!r.ok) throw new Error('Respuesta ' + r.status);
      return r.json();
    });
  }

  function actualizarContador(cantidad) {
    var el = document.querySelector('[data-carrito-total]');
    if (!el) return;
    el.textContent = cantidad;
    el.hidden = cantidad === 0;
  }

  /* ── Menú móvil ───────────────────────────────────────────── */
  (function menuMovil() {
    var burger = document.getElementById('burger');
    var drawer = document.getElementById('drawer');
    var scrim = document.getElementById('scrim');
    var cerrar = document.getElementById('dclose');
    if (!burger || !drawer || !scrim) return;

    var gsapListo = false;
    var cargando = null;
    var focoPrevio = null;

    function cargarGSAP() {
      if (gsapListo) return Promise.resolve(true);
      if (cargando) return cargando;
      cargando = new Promise(function (resolver) {
        var s = document.createElement('script');
        s.src = 'https://cdn.jsdelivr.net/npm/gsap@3.13.0/dist/gsap.min.js';
        s.async = true;
        s.onload = function () { gsapListo = true; resolver(true); };
        s.onerror = function () { resolver(false); };  // sin GSAP el CSS abre igual
        document.head.appendChild(s);
      });
      return cargando;
    }

    // Precarga al rozar el botón: para cuando lo toquen, ya está listo
    if (!menosMovimiento) {
      ['pointerenter', 'touchstart'].forEach(function (ev) {
        burger.addEventListener(ev, cargarGSAP, { once: true, passive: true });
      });
    }

    function elementos() {
      return drawer.querySelectorAll('.drawer__img, .drawer__l, .drawer__f > *');
    }

    function abrir() {
      focoPrevio = document.activeElement;
      drawer.classList.add('open');
      scrim.hidden = false;
      requestAnimationFrame(function () { scrim.classList.add('open'); });
      burger.setAttribute('aria-expanded', 'true');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('locked');
      var primero = drawer.querySelector('a, button');
      if (primero) primero.focus();

      cargarGSAP().then(function () {
        if (menosMovimiento || !window.gsap) return;
        var els = elementos();
        gsap.killTweensOf(els);
        gsap.fromTo(els,
          { x: -24, opacity: 0 },
          { x: 0, opacity: 1, duration: 0.5, stagger: 0.035, ease: 'power3.out', delay: 0.1, clearProps: 'transform' }
        );
      });
    }

    function cerrarMenu() {
      drawer.classList.remove('open');
      scrim.classList.remove('open');
      burger.setAttribute('aria-expanded', 'false');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('locked');
      setTimeout(function () { scrim.hidden = true; }, 430);
      if (window.gsap) gsap.set(elementos(), { clearProps: 'all' });
      if (focoPrevio) focoPrevio.focus();
    }

    burger.addEventListener('click', function () {
      drawer.classList.contains('open') ? cerrarMenu() : abrir();
    });
    scrim.addEventListener('click', cerrarMenu);
    if (cerrar) cerrar.addEventListener('click', cerrarMenu);
    addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('open')) cerrarMenu();
    });
    drawer.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', cerrarMenu);
    });
  })();

  /* ── Quick add ────────────────────────────────────────────── */
  (function quickAdd() {
    var modal = document.getElementById('qm');
    if (!modal) return;

    var titulo = document.getElementById('qmT');
    var precio = document.getElementById('qmP');
    var comparado = document.getElementById('qmC');
    var contOpciones = document.getElementById('qmOpciones');
    var btnAdd = document.getElementById('qmAdd');
    var verMas = document.getElementById('qmVer');
    var cerrarBtn = document.getElementById('qmX');

    var productoActual = null;
    var seleccion = [];
    var focoPrevio = null;

    function cerrar() {
      modal.classList.remove('open');
      document.body.classList.remove('locked');
      setTimeout(function () { modal.hidden = true; }, 300);
      if (focoPrevio) focoPrevio.focus();
    }

    function varianteElegida() {
      if (!productoActual) return null;
      return productoActual.variants.find(function (v) {
        return v.options.every(function (op, i) { return op === seleccion[i]; });
      }) || null;
    }

    function pintarPrecio(v) {
      if (!v) return;
      precio.textContent = dinero(v.price);
      if (v.compare_at_price && v.compare_at_price > v.price) {
        comparado.textContent = '$' + dinero(v.compare_at_price);
        comparado.hidden = false;
      } else {
        comparado.hidden = true;
      }
      btnAdd.disabled = !v.available;
      btnAdd.textContent = v.available
        ? btnAdd.dataset.texto
        : (window.theme && window.theme.agotado) || 'Agotado';
    }

    function pintarOpciones() {
      contOpciones.innerHTML = '';
      if (!productoActual || !productoActual.options) return;

      productoActual.options.forEach(function (nombre, i) {
        var valores = [];
        productoActual.variants.forEach(function (v) {
          if (valores.indexOf(v.options[i]) === -1) valores.push(v.options[i]);
        });
        // Producto de una sola variante: no tiene sentido mostrar selector
        if (valores.length === 1 && valores[0] === 'Default Title') return;

        var fila = document.createElement('div');
        fila.className = 'qrow';

        var etiqueta = document.createElement('div');
        etiqueta.className = 'qrow__l';
        etiqueta.innerHTML = '<span class="dato">' + nombre + '</span><span data-sel="' + i + '">' + seleccion[i] + '</span>';
        fila.appendChild(etiqueta);

        var grupo = document.createElement('div');
        grupo.className = 'qsz';

        valores.forEach(function (val) {
          var b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('aria-pressed', val === seleccion[i] ? 'true' : 'false');
          var partes = String(val).split(' ');
          b.innerHTML = '<b class="cifra">' + partes[0] + '</b>' +
            (partes.length > 1 ? '<span class="dato">' + partes.slice(1).join(' ') + '</span>' : '');
          b.addEventListener('click', function () {
            seleccion[i] = val;
            grupo.querySelectorAll('button').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
            b.setAttribute('aria-pressed', 'true');
            var lbl = etiqueta.querySelector('[data-sel="' + i + '"]');
            if (lbl) lbl.textContent = val;
            pintarPrecio(varianteElegida());
          });
          grupo.appendChild(b);
        });

        fila.appendChild(grupo);
        contOpciones.appendChild(fila);
      });
    }

    function abrir(boton) {
      focoPrevio = boton;
      var handle = boton.dataset.producto;
      var url = boton.dataset.url;
      if (verMas) verMas.href = url || '#';

      // Compra directa sin elegir talla, si el merchant lo activó
      if (document.documentElement.dataset.quickDirecto === 'true') {
        agregar(parseInt(boton.dataset.variante, 10), boton);
        return;
      }

      titulo.textContent = '…';
      precio.textContent = '';
      comparado.hidden = true;
      contOpciones.innerHTML = '';
      modal.hidden = false;
      requestAnimationFrame(function () { modal.classList.add('open'); });
      document.body.classList.add('locked');
      cerrarBtn.focus();

      pedir('/products/' + handle + '.js')
        .then(function (p) {
          productoActual = p;
          titulo.textContent = p.title;
          var vDefecto = p.variants.find(function (v) { return v.available; }) || p.variants[0];
          seleccion = vDefecto.options.slice();
          pintarOpciones();
          pintarPrecio(vDefecto);
        })
        .catch(function () {
          // Si falla la carga, mandamos a la ficha completa
          if (url) location.href = url;
        });
    }

    function agregar(idVariante, boton) {
      var original = boton ? boton.textContent : null;

      // La cantidad sale del selector del PDP. No hay <form>: el
      // carrito va por fetch, así que hay que leerla a mano.
      var campo = document.querySelector('.pcant__i');
      var cuantos = campo ? Math.max(1, parseInt(campo.value, 10) || 1) : 1;

      return pedir('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: idVariante, quantity: cuantos }] })
      })
        .then(function () { return pedir('/cart.js'); })
        .then(function (carrito) {
          actualizarContador(carrito.item_count);
          if (boton) {
            boton.classList.add('ok');
            boton.textContent = '✓ ' + ((window.theme && window.theme.agregado) || 'Agregado');
            setTimeout(function () {
              boton.classList.remove('ok');
              if (original) boton.textContent = original;
            }, 1600);
          }
        })
        .catch(function () {
          if (boton && original) boton.textContent = original;
        });
    }

    document.querySelectorAll('[data-quick-add]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        abrir(b);
      });
    });

    if (btnAdd) {
      btnAdd.addEventListener('click', function () {
        var v = varianteElegida();
        if (!v) return;
        agregar(v.id, btnAdd).then(function () {
          setTimeout(cerrar, 900);
        });
      });
    }

    if (cerrarBtn) cerrarBtn.addEventListener('click', cerrar);
    modal.addEventListener('click', function (e) { if (e.target === modal) cerrar(); });
    addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('open')) cerrar();
    });
  })();

  /* ── Página de producto ───────────────────────────────────── */
  (function paginaProducto() {
    var datos = document.querySelector('[data-variantes]');
    if (!datos) return;

    var variantes;
    try { variantes = JSON.parse(datos.textContent); } catch (e) { return; }

    var inputId = document.querySelector('[data-variante-id]');
    var valorPrecio = document.querySelector('[data-precio-valor]');
    var btnComprar = document.querySelector('[data-btn-comprar]');
    var grupos = document.querySelectorAll('[data-opcion]');
    if (!grupos.length) return;

    function seleccionActual() {
      return Array.prototype.map.call(grupos, function (g) {
        var activo = g.querySelector('[aria-pressed="true"]');
        return activo ? activo.dataset.valor : null;
      });
    }

    function actualizar() {
      var sel = seleccionActual();
      var v = variantes.find(function (x) {
        return x.options.every(function (op, i) { return op === sel[i]; });
      });
      if (!v) return;

      if (inputId) inputId.value = v.id;

      if (valorPrecio) {
        valorPrecio.textContent = dinero(v.price);
        if (!menosMovimiento) {
          valorPrecio.classList.remove('flash');
          void valorPrecio.offsetWidth;
          valorPrecio.classList.add('flash');
        }
      }

      if (btnComprar) {
        btnComprar.disabled = !v.available;
        var etiqueta = btnComprar.querySelector('.cifra');
        if (etiqueta) etiqueta.textContent = '$' + dinero(v.price);
      }

      // Refleja la variante en la URL, para que se pueda compartir
      var url = new URL(location.href);
      url.searchParams.set('variant', v.id);
      history.replaceState({}, '', url);
    }

    grupos.forEach(function (g) {
      g.querySelectorAll('.opt').forEach(function (b) {
        b.addEventListener('click', function () {
          g.querySelectorAll('.opt').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
          b.setAttribute('aria-pressed', 'true');
          actualizar();
        });
      });
    });

  })();

  /* ── Galería del producto ─────────────────────────────────────
     En bloque propio: estaba dentro del de variantes, que sale antes
     con return si el producto no tiene opciones. En esos productos la
     galería no se activaba nunca. */
  (function galeria() {
    var caja = document.getElementById('galmain');
    var thumbs = document.getElementById('thumbs');
    if (!caja) return;

    var fotos = caja.querySelectorAll('.gal__f');
    if (!fotos.length) return;

    function mostrar(i, deslizar) {
      fotos.forEach(function (f, n) {
        f.classList.toggle('on', n === i);
      });
      if (thumbs) {
        thumbs.querySelectorAll('button').forEach(function (b, n) {
          b.classList.toggle('on', n === i);
        });
      }
      // En movil las fotos estan en fila: hay que deslizar hasta ella
      if (deslizar && fotos[i]) {
        caja.scrollTo({
          left: fotos[i].offsetLeft - caja.offsetLeft,
          behavior: menosMovimiento ? 'auto' : 'smooth'
        });
      }
    }

    // Delegacion: funciona aunque los botones se repinten
    document.addEventListener('click', function (e) {
      var t = e.target.closest('#thumbs button');
      if (!t || !thumbs) return;
      var lista = Array.prototype.slice.call(thumbs.querySelectorAll('button'));
      var i = lista.indexOf(t);
      if (i < 0) return;
      mostrar(i, true);
    });

    // Al deslizar en movil, marcar la miniatura que toca
    var pendiente = false;
    caja.addEventListener('scroll', function () {
      if (pendiente) return;
      pendiente = true;
      requestAnimationFrame(function () {
        pendiente = false;
        if (caja.scrollWidth <= caja.clientWidth) return;   // no hay carrusel
        var centro = caja.scrollLeft + caja.clientWidth / 2;
        var cerca = 0, dmin = Infinity;
        fotos.forEach(function (f, n) {
          var d = Math.abs((f.offsetLeft + f.offsetWidth / 2) - centro - caja.offsetLeft);
          if (d < dmin) { dmin = d; cerca = n; }
        });
        if (thumbs) {
          thumbs.querySelectorAll('button').forEach(function (b, n) {
            b.classList.toggle('on', n === cerca);
          });
        }
      });
    }, { passive: true });
  })();

  /* ── Carrito ──────────────────────────────────────────────── */
  (function carrito() {
    var form = document.querySelector('[data-form-carrito]');
    if (!form) return;

    function cambiar(clave, cantidad, linea) {
      linea.style.opacity = '.5';
      pedir('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: clave, quantity: cantidad })
      })
        .then(function () { location.reload(); })
        .catch(function () { linea.style.opacity = ''; });
    }

    form.querySelectorAll('.linea').forEach(function (linea) {
      var input = linea.querySelector('[data-cant-input]');
      var clave = linea.dataset.clave;

      linea.querySelectorAll('[data-cant]').forEach(function (b) {
        b.addEventListener('click', function () {
          var actual = parseInt(input.value, 10) || 0;
          var nueva = b.dataset.cant === 'mas' ? actual + 1 : Math.max(0, actual - 1);
          input.value = nueva;
          cambiar(clave, nueva, linea);
        });
      });

      if (input) {
        input.addEventListener('change', function () {
          cambiar(clave, Math.max(0, parseInt(input.value, 10) || 0), linea);
        });
      }

      var quitar = linea.querySelector('[data-quitar]');
      if (quitar) {
        quitar.addEventListener('click', function () { cambiar(clave, 0, linea); });
      }
    });
  })();

  /* ── Filtros de colección ─────────────────────────────────── */
  (function filtros() {
    document.querySelectorAll('#filtros .filtro').forEach(function (b) {
      b.addEventListener('click', function () {
        var activo = b.getAttribute('aria-pressed') === 'true';
        var destino = activo ? b.dataset.urlQuitar : b.dataset.url;
        if (destino) location.href = destino;
      });
    });

    var orden = document.querySelector('[data-ordenar]');
    if (orden) {
      orden.addEventListener('change', function () {
        var url = new URL(location.href);
        url.searchParams.set('sort_by', orden.value);
        url.searchParams.delete('page');
        location.href = url.toString();
      });
    }
  })();

  /* ── Revelado al hacer scroll y contadores ────────────────── */
  (function animaciones() {
    if (!('IntersectionObserver' in window) || menosMovimiento) {
      document.querySelectorAll('.rv, .stock').forEach(function (e) { e.classList.add('in'); });
      document.querySelectorAll('[data-count]').forEach(function (e) {
        e.textContent = parseFloat(e.dataset.count).toLocaleString('es-MX');
      });
      return;
    }

    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('in');
        io.unobserve(e.target);
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -6% 0px' });

    document.querySelectorAll('.rv, .stock, .ship').forEach(function (e) { io.observe(e); });

    var ioNum = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;

        // El valor puede traer prefijo y sufijo: "+10k", "18k", ".925".
        // Se anima solo el numero y se conserva lo demas.
        var bruto = el.dataset.count;
        var m = bruto.match(/^([^\d.,-]*)([\d.,]+)(.*)$/);
        if (!m) { ioNum.unobserve(el); return; }

        var pre = m[1];
        var crudo = m[2].replace(/,/g, '');
        var suf = m[3];
        var fin = parseFloat(crudo);
        if (isNaN(fin)) { ioNum.unobserve(el); return; }

        // Decimales: se conservan los que traiga el valor original
        var punto = crudo.indexOf('.');
        var dec = punto < 0 ? 0 : crudo.length - punto - 1;

        var inicio = performance.now();
        (function paso(t) {
          var p = Math.min((t - inicio) / 900, 1);
          var v = fin * (1 - Math.pow(1 - p, 3));
          var txt = dec > 0
            ? v.toFixed(dec)
            : Math.round(v).toLocaleString('es-MX');
          el.textContent = pre + txt + suf;
          if (p < 1) requestAnimationFrame(paso);
        })(inicio);
        ioNum.unobserve(el);
      });
    }, { threshold: 0.5 });

    // Con prefers-reduced-motion activado no se anima: el valor real
    // ya esta en el HTML, asi que no hay nada que hacer.
    if (!menosMovimiento) {
      document.querySelectorAll('[data-count]').forEach(function (e) { ioNum.observe(e); });
    }
  })();


  /* ═══════════════════════════════════════════════════════════════
     BUSCADOR EN VIVO
     Usa el endpoint predictivo de Shopify. Los resultados salen
     debajo del campo mientras se escribe, sin recargar la pagina.
     ═══════════════════════════════════════════════════════════════ */
  (function () {
    var panel = document.getElementById('bus');
    if (!panel) return;

    var campo  = document.getElementById('busQ');
    var salida = document.getElementById('busR');
    var cerrar = document.getElementById('busX');
    var sugs   = document.getElementById('busSug');
    var espera = null;      // temporizador anti-rebote
    var vuelo  = null;      // peticion en curso, para poder cancelarla
    var ultimo = '';

    function abrir(e) {
      if (e) e.preventDefault();
      panel.hidden = false;
      document.body.style.overflow = 'hidden';
      setTimeout(function () { campo.focus(); }, 40);
    }

    function ocultar() {
      panel.hidden = true;
      document.body.style.overflow = '';
      salida.innerHTML = '';
      campo.value = '';
      ultimo = '';
      if (sugs) sugs.hidden = false;      // vuelven las categorias
      campo.setAttribute('aria-expanded', 'false');
    }

    // El icono de lupa abre el panel en vez de irse a /search
    document.querySelectorAll('a[href*="/search"]').forEach(function (a) {
      if (a.closest('.hd')) a.addEventListener('click', abrir);
    });

    if (cerrar) cerrar.addEventListener('click', ocultar);
    panel.addEventListener('click', function (e) {
      if (e.target === panel) ocultar();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !panel.hidden) ocultar();
    });

    function pinta(datos, termino) {
      var items = (datos.resources && datos.resources.results && datos.resources.results.products) || [];

      if (!items.length) {
        salida.innerHTML = '<p class="bus__msg">Nada con «' +
          termino.replace(/[<>&]/g, '') + '». Prueba con otra palabra.</p>';
        return;
      }

      // El endpoint de busqueda devuelve pesos como texto ('799.00'),
      // no centavos. Usar dinero() aqui partia el precio entre 100.
      function precioBusqueda(v) {
        var n = parseFloat(v);
        if (isNaN(n)) return '';
        return '$' + n.toLocaleString('es-MX', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        });
      }

      var html = items.map(function (p) {
        var img = p.featured_image && p.featured_image.url
          ? '<img src="' + p.featured_image.url + '" alt="" width="52" height="52" loading="lazy">'
          : '<img alt="" width="52" height="52">';
        return '<a class="bus__item" href="' + p.url + '">' + img +
               '<span><b>' + p.title + '</b>' +
               '<span class="precio-mini cifra">' + (p.price ? precioBusqueda(p.price) : '') + '</span>' +
               '</span></a>';
      }).join('');

      html += '<a class="bus__todos" href="/search?q=' + encodeURIComponent(termino) +
              '&type=product"><span>Ver todos los resultados</span>' +
              '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" ' +
              'stroke-width="2.5" aria-hidden="true"><path d="m9 6 6 6-6 6"/></svg></a>';
      salida.innerHTML = html;
    }

    function buscar() {
      var q = campo.value.trim();
      if (q === ultimo) return;
      ultimo = q;

      if (q.length < 2) {
        salida.innerHTML = '';
        if (sugs) sugs.hidden = false;
        campo.setAttribute('aria-expanded', 'false');
        return;
      }

      // Al buscar, las categorias estorban
      if (sugs) sugs.hidden = true;

      if (vuelo) vuelo.abort();
      vuelo = new AbortController();
      campo.setAttribute('aria-expanded', 'true');
      salida.innerHTML = '<p class="bus__msg">Buscando…</p>';

      fetch('/search/suggest.json?q=' + encodeURIComponent(q) +
            '&resources[type]=product&resources[limit]=6', { signal: vuelo.signal })
        .then(function (r) { return r.json(); })
        .then(function (d) { pinta(d, q); })
        .catch(function (err) {
          if (err.name === 'AbortError') return;   // la cancelamos nosotros
          salida.innerHTML = '<p class="bus__msg">No se pudo buscar. Intenta de nuevo.</p>';
        });
    }

    // Anti-rebote: no dispara una peticion por cada tecla
    campo.addEventListener('input', function () {
      clearTimeout(espera);
      espera = setTimeout(buscar, 220);
    });
  })();


  /* Acordeon del menu lateral: cada grupo abre y cierra sus categorias */
  (function () {
    var drawer = document.getElementById('drawer');
    if (!drawer) return;

    drawer.addEventListener('click', function (e) {
      var b = e.target.closest('.drawer__gb');
      if (!b) return;

      var abierto = b.getAttribute('aria-expanded') === 'true';
      var grupo = b.closest('.drawer__g');
      var sub = grupo && grupo.nextElementSibling;

      b.setAttribute('aria-expanded', abierto ? 'false' : 'true');
      if (sub && sub.classList.contains('drawer__sub')) sub.hidden = abierto;
    });
  })();


  /* Desplegables de categoria: abren al pulsar, no al pasar por encima.
     El hover se mantiene en escritorio como atajo. */
  (function () {
    var grupos = document.querySelectorAll('.chip-g');
    if (!grupos.length) return;

    function cerrarTodos(menos) {
      grupos.forEach(function (g) {
        if (g === menos) return;
        g.classList.remove('abierto');
        var b = g.querySelector('.chip-g__b');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
    }

    grupos.forEach(function (g) {
      var boton = g.querySelector('.chip-g__b');
      if (!boton) return;

      boton.addEventListener('click', function (e) {
        e.preventDefault();
        var abierto = g.classList.contains('abierto');
        cerrarTodos(g);
        g.classList.toggle('abierto', !abierto);
        boton.setAttribute('aria-expanded', abierto ? 'false' : 'true');
      });
    });

    // Pulsar fuera lo cierra
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.chip-g')) cerrarTodos(null);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') cerrarTodos(null);
    });
  })();


  /* El encabezado se oculta al bajar y reaparece al subir.
     Solo se activa si el ajuste esta encendido en el editor. */
  (function () {
    var hd = document.querySelector('.hd');
    if (!hd || !hd.dataset.ocultar) return;

    var ultimo = window.scrollY;
    var alto = hd.offsetHeight;
    var pendiente = false;

    function revisar() {
      var y = window.scrollY;

      // Arriba del todo siempre visible
      if (y <= alto) {
        hd.classList.remove('hd--oculto');
      } else if (y > ultimo + 6) {
        hd.classList.add('hd--oculto');      // bajando
      } else if (y < ultimo - 6) {
        hd.classList.remove('hd--oculto');   // subiendo
      }

      ultimo = y;
      pendiente = false;
    }

    window.addEventListener('scroll', function () {
      if (pendiente) return;
      pendiente = true;
      requestAnimationFrame(revisar);
    }, { passive: true });
  })();

  /* La barra del header abre el panel de busqueda en vivo */
  (function () {
    var campo = document.querySelector('[data-abre-busqueda]');
    var panel = document.getElementById('bus');
    if (!campo || !panel) return;

    campo.addEventListener('focus', function (e) {
      e.preventDefault();
      campo.blur();
      panel.hidden = false;
      document.body.style.overflow = 'hidden';
      var dentro = document.getElementById('busQ');
      if (dentro) setTimeout(function () { dentro.focus(); }, 40);
    });
  })();





  /* La categoria activa, siempre a la vista.
     Al cargar se centra en la barra sin animacion: si se anima, el
     usuario ve el salto y parece un error. */
  (function () {
    var barra = document.querySelector('.chips-sc');
    if (!barra) return;

    var activo = barra.querySelector('[aria-current="page"]');
    if (!activo) return;

    // Solo si de verdad hay desbordamiento
    if (barra.scrollWidth <= barra.clientWidth) return;

    var centro = activo.offsetLeft - (barra.clientWidth / 2) + (activo.offsetWidth / 2);
    barra.scrollLeft = Math.max(0, centro);
  })();


  /* Videos del carrusel: arrancan al entrar en pantalla y se detienen
     al salir. Asi no se descargan todos de golpe. */
  (function ugc() {
    var vids = document.querySelectorAll('.ugc__v');
    if (!vids.length) return;

    // Con movimiento reducido no se reproducen solos
    if (menosMovimiento) return;

    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          if (v.preload === 'none') v.preload = 'auto';
          var p = v.play();
          if (p) p.catch(function () { /* el navegador puede bloquearlo */ });
        } else {
          v.pause();
        }
      });
    }, { threshold: 0.4 });

    vids.forEach(function (v) { io.observe(v); });
  })();


  /* Flechas del carrusel de videos.

     Solo se encienden si la fila DESBORDA de verdad. Si los videos caben
     en el ancho, el CSS ya los centra y no hay nada que desplazar: unas
     flechas ahi solo estorban. Se recalcula al cambiar el tamano de la
     ventana porque lo que desborda en movil cabe en escritorio. */
  (function ugcFlechas() {
    var cajas = document.querySelectorAll('[data-ugc]');
    if (!cajas.length) return;

    cajas.forEach(function (caja) {
      var fila = caja.querySelector('.ugc__l');
      var prev = caja.querySelector('[data-ugc-prev]');
      var next = caja.querySelector('[data-ugc-next]');
      if (!fila || !prev || !next) return;

      function desborda() {
        return fila.scrollWidth - fila.clientWidth > 4;
      }

      function actualizar() {
        var hay = desborda();
        prev.hidden = !hay;
        next.hidden = !hay;
        if (!hay) return;

        // Margen de 4px: los navegadores redondean scrollLeft y sin el
        // la flecha del final no se apaga nunca.
        var fin = fila.scrollWidth - fila.clientWidth - 4;
        prev.disabled = fila.scrollLeft <= 4;
        next.disabled = fila.scrollLeft >= fin;
      }

      function mover(signo) {
        // Un paso = una tarjeta con su hueco, medido del DOM real para
        // no repetir aqui el ancho que el cliente ajusta en el editor.
        var tarjeta = fila.querySelector('li');
        var paso = tarjeta ? tarjeta.getBoundingClientRect().width + 11 : fila.clientWidth * 0.8;
        fila.scrollBy({
          left: paso * signo,
          behavior: menosMovimiento ? 'auto' : 'smooth'
        });
      }

      prev.addEventListener('click', function () { mover(-1); });
      next.addEventListener('click', function () { mover(1); });
      fila.addEventListener('scroll', actualizar, { passive: true });

      window.addEventListener('resize', actualizar);

      // Las imagenes y videos aun no tienen medidas al cargar el script:
      // sin esto, scrollWidth mide de menos y las flechas no salen.
      if ('ResizeObserver' in window) {
        new ResizeObserver(actualizar).observe(fila);
      } else {
        window.addEventListener('load', actualizar);
      }

      actualizar();
    });
  })();


  /* Selector de cantidad del PDP */
  (function cantidad() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest('.pcant__b');
      if (!b) return;
      var caja = b.closest('.pcant__c');
      var input = caja && caja.querySelector('.pcant__i');
      if (!input) return;

      var paso = parseInt(b.dataset.cant, 10) || 0;
      var v = (parseInt(input.value, 10) || 1) + paso;
      input.value = Math.max(1, v);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  })();

  /* FAQ del PDP: al abrir una se cierra la anterior */
  (function faqPdp() {
    var items = document.querySelectorAll('.pfaq__i');
    if (!items.length) return;
    items.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        items.forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
  })();


  /* WhatsApp flotante: aparece al bajar. Nada mas cargar la pagina
     estorba, y el usuario todavia no tiene nada que preguntar. */
  (function whatsapp() {
    var wa = document.querySelector('[data-wa]');
    if (!wa) return;

    var pendiente = false;
    function revisar() {
      wa.classList.toggle('on', window.scrollY > 500);
      pendiente = false;
    }

    window.addEventListener('scroll', function () {
      if (pendiente) return;
      pendiente = true;
      requestAnimationFrame(revisar);
    }, { passive: true });

    revisar();
  })();


  /* FAQ del home con apertura suave.
     <details> no se puede animar con CSS solo: oculta su contenido con
     display:none, y desde ahi el navegador salta al estado final. Se
     controla a mano: primero open (existe en el DOM), en el siguiente
     frame la clase que anima. Al cerrar, se espera la transicion. */
  (function faqSuave() {
    var items = document.querySelectorAll('.faq__l .faq__i');
    if (!items.length) return;

    function cerrar(d) {
      d.classList.remove('abriendo');
      if (menosMovimiento) { d.open = false; return; }
      var fin = function () {
        d.open = false;
        d.removeEventListener('transitionend', fin);
      };
      d.addEventListener('transitionend', fin);
      // Por si la transicion no dispara (pestaña oculta)
      setTimeout(function () { if (!d.classList.contains('abriendo')) d.open = false; }, 420);
    }

    function abrir(d) {
      d.open = true;
      if (menosMovimiento) { d.classList.add('abriendo'); return; }
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { d.classList.add('abriendo'); });
      });
    }

    items.forEach(function (d) {
      var s = d.querySelector('summary');
      if (!s) return;

      s.addEventListener('click', function (e) {
        e.preventDefault();
        var abierto = d.classList.contains('abriendo');

        // Solo una abierta a la vez
        items.forEach(function (o) {
          if (o !== d && o.classList.contains('abriendo')) cerrar(o);
        });

        if (abierto) cerrar(d);
        else abrir(d);
      });
    });
  })();


  /* Filtros del FAQ por categoria */
  (function faqFiltros() {
    document.querySelectorAll('.faq__f').forEach(function (barra) {
      var seccion = barra.closest('section') || document;
      var lista = seccion.querySelector('.faq__l');
      if (!lista) return;

      barra.addEventListener('click', function (e) {
        var b = e.target.closest('.faq__fb');
        if (!b) return;

        barra.querySelectorAll('.faq__fb').forEach(function (x) {
          x.classList.toggle('on', x === b);
        });

        var cat = b.dataset.cat || '';
        lista.querySelectorAll('.faq__i').forEach(function (d) {
          var suya = !cat || d.dataset.cat === cat;
          d.hidden = !suya;
          // Al filtrar se cierran: una abierta y oculta descoloca
          if (!suya) {
            d.open = false;
            d.classList.remove('abriendo');
          }
        });
      });
    });
  })();

})();
